import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE } from "@/config/site";
import { trackEvent, EVENTS } from "@/utils/track";

const NAV_LINKS = [
  { label: "El problema", href: "#problema" },
  { label: "La solución", href: "#solucion" },
  { label: "Cómo funciona", href: "#como-funciona" },
  { label: "Resultados", href: "#resultados" },
  { label: "Preguntas frecuentes", href: "#faq" },
  { label: "Blog", href: "/blog" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-[#E4E9F2] bg-white/85 backdrop-blur-xl">
      <nav
        className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8"
        aria-label="Navegación principal"
      >
        <a
          href="#inicio"
          data-testid="nav-logo"
          className="flex items-center"
          onClick={() => setOpen(false)}
        >
          <img src="/logo-horizontal.png" alt={SITE.name} className="h-5 w-auto" />
        </a>

        <div className="hidden items-center gap-7 lg:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.slice(1)}`}
              className="text-sm font-medium text-steel transition-colors duration-200 hover:text-navy"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden lg:block">
          <Button
            asChild
            data-testid="nav-cta-button"
            className="rounded-lg bg-navy px-5 font-semibold text-white shadow-sm transition-all duration-200 hover:bg-navy-light hover:shadow-md"
            onClick={() => trackEvent(EVENTS.CTA_PRINCIPAL, { ubicacion: "navbar" })}
          >
            <a href="#calculadora">Calcula tus pérdidas</a>
          </Button>
        </div>

        <button
          type="button"
          data-testid="nav-mobile-toggle"
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-[#E4E9F2] text-navy lg:hidden"
          aria-label={open ? "Cerrar menú" : "Abrir menú"}
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="border-t border-[#E4E9F2] bg-white px-4 pb-6 pt-2 lg:hidden"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-mobile-link-${link.href.slice(1)}`}
              className="block rounded-lg px-3 py-3 text-base font-medium text-navy hover:bg-platinum"
              onClick={() => setOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <Button
            asChild
            data-testid="nav-mobile-cta-button"
            className="mt-3 w-full rounded-lg bg-navy py-6 font-semibold text-white hover:bg-navy-light"
            onClick={() => {
              setOpen(false);
              trackEvent(EVENTS.CTA_PRINCIPAL, { ubicacion: "navbar_movil" });
            }}
          >
            <a href="#calculadora">Calcula tus pérdidas</a>
          </Button>
        </div>
      )}
    </header>
  );
}
